import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { getThreeLetterCountryCode } from "@faire/web--source/common/consts/TWO_TO_THREE_LETTER_COUNTRY_ISO_CODE";
import { ILocaleKey } from "@faire/web-api--source/indigofair/locale/ILocaleKey";
import invert from "lodash/invert";
import { THREE_TO_TWO_LETTER_LANGUAGE_CODE } from "./THREE_TO_TWO_LETTER_LANGUAGE_CODE";
export var TWO_TO_THREE_LETTER_LANGUAGE_CODE = invert(THREE_TO_TWO_LETTER_LANGUAGE_CODE);
export var localeStringToLocaleKey = function(localeString) {
    var _localeString_toUpperCase_split = _sliced_to_array(localeString.toUpperCase().split(/[^a-zA-Z]/), 2), languageTwo = _localeString_toUpperCase_split[0], countryTwo = _localeString_toUpperCase_split[1];
    var language = TWO_TO_THREE_LETTER_LANGUAGE_CODE[languageTwo !== null && languageTwo !== void 0 ? languageTwo : ""];
    var country = countryTwo ? getThreeLetterCountryCode(countryTwo) : undefined;
    return ILocaleKey.build({
        country: country,
        language: language
    });
};
